import styled from 'styled-components';

export const Inputs = styled.div`
  display: grid;
  grid-template-columns: ${({ $withoutButton }) => ($withoutButton ? '1fr' : '1fr 36px')};
  grid-template-rows: auto auto;
  column-gap: 10px;
`;
